import { styled } from 'linaria/react';

export const Button = styled.button` 
	height: 40px;
  width: 80%;
  margin: 40px auto;
	text-align: center;
	display: flex;
	justify-content: center;
  background: #087587;
  color: #fff;
  transition: all .4s;
  border: none;
  border-radius: 30px;
  padding: 12px;
  font-size: 16px;
  outline: none;
  max-width: 300px;
  font-family: 'Montserrat',sans-serif;
  font-weight: 300;           
`;
